import { conditionType } from "../../../components/modals/AdminModal/AdminModalTypes";
import { runInAction, set } from "mobx";
import Button from "../../../components/utilities/Button";
import Tree from "../../../components/admin/tree/Tree";
import styles from "./NavigationAdminContainer.module.scss";
import { useStores } from "../../../stores/useStores";
import ClickableLink from "../../../components/utilities/ClickableLink";
import FontAwesome from "../../../components/utilities/FontAwesome";
import { useFeatureFlags } from "../../../utils/featureFlags/useFeatureFlags";

export function TopLinksTab() {
  const { organizationStore, modalStore } = useStores();
  const { pages_directory } = useFeatureFlags();

  function toggleModal(condition = conditionType.ADD_TOPLINK, nodeInfo = {}) {
    modalStore.addModal({
      type: "admin",
      id: "navigation-modal",
      condition,
      nodeInfo,
      navigation: organizationStore._navigation,
      parent_id: organizationStore.organization.id,
      navigationUpdater: async function (navigation) {
        const result = await organizationStore.fetchClient(
          "organizations",
          "organizations_navigations_bulk_update",
          {
            organization_pk: organizationStore.organization.id,
            data: [navigation],
          },
        );

        if (result?.data) {
          runInAction(() => {
            set(
              organizationStore._navigation,
              organizationStore.navigation.map((nav) => {
                if (nav.id === navigation.id) {
                  return JSON.parse(result.data)[0];
                }
                return nav;
              }),
            );
          });
        }
      },
      navigationCreator: async function (navigation) {
        const obj = await organizationStore.fetchClient(
          "organizations",
          "organizations_navigations_create",
          {
            organization_pk: organizationStore.organization.id,
            data: {
              title: navigation.title,
              type: navigation.type,
              external_url: navigation.external_url,
              icon: navigation.icon,
              class_field: navigation.class_field,
              description: navigation.description,
              path: navigation.path,
              enabled: navigation.enabled,
              parent_id: navigation.parent_id,
              organization_id: navigation.organization_id,
              organization: navigation.organization,
              keep_site_context: navigation.keep_site_context,
            },
          },
        );

        if (obj?.data) {
          runInAction(() => {
            set(organizationStore._navigation, [
              ...organizationStore.navigation,
              JSON.parse(obj.data),
            ]);
          });
        }

        return JSON.parse(obj.data);
      },
    });
  }

  return (
    <div id="top-links-tab">
      <header className="sb-settings-block-content-heading">
        <h4>Top Links</h4>
      </header>
      <p>
        When configuring top links, please pay special attention to the type and
        quantity of links that you are using. Too many links can be unmanageable
        and might not be seen by all users (i.e. if the links continue past the
        height or width of the menu bar/panel. View our{" "}
        <a
          href="https://docs.google.com/document/d/1uD2yx27m6uajuen8gyTpmMCwc7iPDFk4up9dQRCD-Ao/preview"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          help guide
        </a>{" "}
        for an explanation best practices for each link type.
      </p>
      {pages_directory && (
        <>
          <span>To View all current pages on your site visit the&nbsp;</span>
          <ClickableLink href={"/pages"}>
            <FontAwesome fixedWidth name="fas fa-book-atlas" ariaHidden />
            Pages Directory
          </ClickableLink>
        </>
      )}
      <div id="nav-tree">
        <Button className={styles.addLinkButton} onClick={() => toggleModal()}>
          Add Top Link
        </Button>
        <Tree isTouch={false} toggleModal={toggleModal} />
      </div>
    </div>
  );
}
